<div>

  <h1>User Collection</h1>
  <div class="user-item" *ngFor="let user of users">
    <div class="flex items-center">
      <p>{{user.email}}</p>
      <button (click)="remove.emit(user.id)" data-test="remove-button" class="bg-blue-100">Remove from Collection</button>
    </div>
  </div>

</div>
